"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
function RadioButton({ className, label, checked, inputRef, ...restInputProps }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: className, children: (0, jsx_runtime_1.jsxs)("label", { className: (0, classnames_1.default)(labelStyles(!!checked)), children: [(0, jsx_runtime_1.jsx)("input", { ref: inputRef, className: (0, classnames_1.default)(inputStyles()), checked: checked, type: "radio", ...restInputProps }), (0, jsx_runtime_1.jsx)("span", { children: label })] }) }));
}
exports.RadioButton = RadioButton;
// Styling is based on https://moderncss.dev/pure-css-custom-styled-radio-buttons/
function labelStyles(checked) {
    return {
        "bg-gr-bluestone": !checked,
        "bg-gr-red": checked,
        border: true,
        "border-gr-input-border": !checked,
        flex: true,
        "gap-2": true,
        "items-center": true,
        rounded: true,
        "px-4": true,
        "py-5": true,
        "text-white": checked,
        "focus-within:outline": true,
        "focus-within:outline-2": true,
        "focus-within:outline-gr-sapphire": true,
        "focus-within:outline-offset-2": true,
    };
}
function inputStyles() {
    return {
        "appearance-none": true,
        "bg-gr-bluestone": true,
        "border-2": true,
        "border-gr-input-border": true,
        "h-6": true,
        "inline-block": true,
        "rounded-full": true,
        "w-6": true,
        "checked:border-gr-red": true,
        "checked:grid": true,
        "checked:place-content-center": true,
        // Use the before pseudo-element to render the inner red circle
        "checked:before:bg-gr-red": true,
        "checked:before:content-[' ']": true,
        "checked:before:h-2": true,
        "checked:before:rounded-full": true,
        "checked:before:w-2": true,
        // Focus ring appears on the entire outer label
        "focus:outline-none": true,
    };
}
